import { create } from 'zustand'
export const useCurrentAccountStore = create(set => ({
  dateExpiryStart: null,
  setDateExpiryStart: date => set(() => ({ dateExpiryStart: date })),
  dateExpiryEnd: null,
  setDateExpiryEnd: date => set(() => ({ dateExpiryEnd: date })),
  transactionData: [],
  setTransactionData: data => set(() => ({ transactionData: data })),
  transactions: [],
  setTransactions: data => set(() => ({ transactions: data })),
  defaultFilterApplied: false,
  setDefaultFilterApplied: value =>
    set(() => ({ defaultFilterApplied: value })),
  historyData: [],
  setHistoryData: data => set(() => ({ historyData: data })),
  isLoading: false,
  setIsLoading: data => set(() => ({ isLoading: data })),
  resetStore: () =>
    set(() => ({
      dateExpiryStart: null,
      dateExpiryEnd: null,
      transactionData: [],
      transactions: [],
      defaultFilterApplied: false,
      historyData: [],
      isLoading: false,
    })),
}))
